<app-panel-header-image-view pretitle="{{'Statistics' | transloco}}" title="{{'world_record' | transloco}}" banner_image="../../../modules/custom/wa_angular/app/assets/images/banner-world-records.jpg"></app-panel-header-image-view>
<app-app-content-page-wrapper>
  <app-filters-world-records></app-filters-world-records>
  <app-world-records-list></app-world-records-list>
  <hr class="spacer" />
  <app-news-panel
  @fade
  [title]="'Related news' | transloco"
  [news]="world_records_service.newsStore.data"
></app-news-panel>
</app-app-content-page-wrapper>
